import React from "react"

const CopyrightFooter = props => {
  return <p>© {new Date().getFullYear()} Viettin solution Co, Ltd.</p>
}

export default CopyrightFooter
